import { useMutation } from '@tanstack/react-query';
import { handleDownload } from '@tenant/utility/Utils';
import { getExportCSV } from 'api/appManager';
import { toast } from 'react-toastify';

const useExportListApp = (query) => {
  const mutate = useMutation({
    mutationFn: () => getExportCSV(query),
    onSuccess: (data) => {
      toast.success('Export successful!');
      const fileName = `apps_${new Date()
        .toLocaleString('en-GB')
        .replace(/[\/,]/g, '_')
        .replace(/:/g, '_')
        .replace(/\s/g, '_')}.csv`;
      handleDownload(data, fileName);
    },
    onError: (error) => {
      console.error('Error export list app:', error);
      toast.error('Export failed!');
      // Handle the error, show error message, etc.
    },
  });

  return mutate;
};

export default useExportListApp;
